$(document).ready(function(){

  /* =========================================================
     BUY / ADD
     ========================================================= */

  $('.buyadd').click(function(){
    $(this).parents().siblings('.item-buy').show();
  });


  /* =========================================================
     MAIN MENU
     ========================================================= */

  $('.menu').click(function(e){

    e.preventDefault();
    e.stopPropagation();

    $('.megamenu').toggle();
  });


  /* =========================================================
     MOBILE ACCORDION
     ========================================================= */

  $('.row-nav').click(function(e){

    e.preventDefault();
    e.stopPropagation();

    var $current = $(this);
    var $currentArea = $current.next('.link-area');

    $('.row-nav')
      .not($current)
      .next('.link-area')
      .stop(true, true)
      .slideUp();

    $('.row-nav')
      .not($current)
      .children('.icon-dd')
      .removeClass('icon180');

    $currentArea
      .stop(true, true)
      .slideToggle();

    $current
      .children('.icon-dd')
      .toggleClass('icon180');
  });


  /* =========================================================
     TOP BAR CLOSE
     ========================================================= */

  $('.topex').click(function(e){

    e.preventDefault();

    $('.topbar').remove();
    $('.topspace').slideUp();
  });


  /* =========================================================
     SEARCH
     ========================================================= */

  $('#searchnow').click(function(){

    $('.nav-search').toggle();

    $('#search').focus();
  });


  /* =========================================================
     PRODUCT IMAGE
     ========================================================= */

  $('.single-option-selector').change(function(){

    $('#img1').attr('src', '');
  });


  /* =========================================================
     DESKTOP MEGA MENU SETTINGS
     ========================================================= */

  var openTimer = null;
  var closeTimer = null;

  var MENU_OPEN_DELAY = 150;
  var MENU_CLOSE_DELAY = 350;

  var lastKeyboardTrigger = null;


  function isDesktop(){

    return window.innerWidth >= 992;
  }


  /* =========================================================
     CLOSE ALL MEGA MENUS
     ========================================================= */

  function closeAllMegaMenus(){

    clearTimeout(openTimer);
    clearTimeout(closeTimer);

    $('.megamenu .link-area').hide();

    $('.megamenu').hide();

    $('.row-links')
      .removeClass('hide-sm');

    $('.row-links .nav-dd')
      .css('opacity', '1');

    $('.row-links .navdd')
      .attr('aria-expanded', 'false');
  }


  /* =========================================================
     OPEN ONE MEGA MENU
     ========================================================= */

  function openMegaMenu($navItem, moveFocus){

    if (!isDesktop()) return;

    clearTimeout(openTimer);
    clearTimeout(closeTimer);

    var thisnav = $navItem.data('num');

    /*
     IMPORTANT:
     Hide EVERY menu first.
     This prevents Fabric/Shop by Brand from appearing
     inside other menu sections.
    */
    $('.megamenu .link-area').hide();

    /*
     Show the main mega menu.
    */
    $('.megamenu').show();

    /*
     Hide the normal top links visually.
    */
    $('.row-links').addClass('hide-sm');

    /*
     Reset opacity.
    */
    $('.row-links .nav-dd').css('opacity', '1');

    /*
     Dim all other top-level items.
    */
    $navItem
      .siblings()
      .css('opacity', '.6');

    /*
     Show ONLY the selected menu.
    */
    var $currentMenu = $('#nav-' + thisnav);

    if ($currentMenu.length) {

      $currentMenu.show();

    } else {

      /*
       If there is no submenu, close the mega menu.
      */
      closeAllMegaMenus();

      return;
    }

    /*
     Accessibility state.
    */
    $('.row-links .navdd')
      .attr('aria-expanded', 'false');

    $navItem
      .find('.navdd')
      .attr('aria-expanded', 'true');

    /*
     Remember keyboard trigger.
    */
    if (moveFocus) {

      lastKeyboardTrigger =
        $navItem.find('.navdd').get(0);

      /*
       Focus first link.
      */
      setTimeout(function(){

        $currentMenu
          .find('a.menulink')
          .first()
          .focus();

      }, 0);
    }
  }


  /* =========================================================
     DESKTOP HOVER OPEN
     ========================================================= */

  $('.nav-dd:not(.reglink)').on('mouseenter', function(){

    if (!isDesktop()) return;

    var $this = $(this);

    clearTimeout(openTimer);
    clearTimeout(closeTimer);

    openTimer = setTimeout(function(){

      openMegaMenu($this, false);

    }, MENU_OPEN_DELAY);
  });


  /* =========================================================
     DESKTOP HOVER LEAVE
     ========================================================= */

  $('.nav-dd:not(.reglink)').on('mouseleave', function(){

    if (!isDesktop()) return;

    clearTimeout(openTimer);

    var $this = $(this);

    $this
      .siblings()
      .css('opacity', '1');

    closeTimer = setTimeout(function(){

      /*
       Only close if cursor isn't inside the mega menu.
      */
      if (!$('.wide-menu:hover').length) {

        closeAllMegaMenus();
      }

    }, MENU_CLOSE_DELAY);
  });


  /* =========================================================
     ENTER MEGA MENU
     ========================================================= */

  $('.wide-menu').on('mouseenter', function(){

    if (!isDesktop()) return;

    clearTimeout(closeTimer);
    clearTimeout(openTimer);
  });


  /* =========================================================
     LEAVE MEGA MENU
     ========================================================= */

  $('.wide-menu').on('mouseleave', function(){

    if (!isDesktop()) return;

    closeTimer = setTimeout(function(){

      closeAllMegaMenus();

    }, MENU_CLOSE_DELAY);
  });

  /* =========================================================
   CLICK OUTSIDE MEGA MENU
   ========================================================= */

  $('.menu-blur').on('click', function(e) {

    e.preventDefault();
    e.stopPropagation();

    closeAllMegaMenus();

  });


  /* =========================================================
     ENTER / SPACE
     ========================================================= */

  $('.nav-dd:not(.reglink) .navdd').on('keydown', function(e){

    if (!isDesktop()) return;

    if (e.key === 'Enter' || e.key === ' ') {

      e.preventDefault();
      e.stopPropagation();

      openMegaMenu(
        $(this).closest('.nav-dd'),
        true
      );
    }
  });


  /* =========================================================
     ESCAPE
     ========================================================= */

  $(document).on('keydown', function(e){

    if (!isDesktop()) return;

    if (e.key !== 'Escape') return;

    if (!$('.megamenu:visible').length) return;

    e.preventDefault();
    e.stopPropagation();

    closeAllMegaMenus();

    if (lastKeyboardTrigger) {

      $(lastKeyboardTrigger).focus();
    }
  });


  /* =========================================================
     LEFT / RIGHT / DOWN
     ========================================================= */

  $('.row-links .navdd').on('keydown', function(e){

    if (!isDesktop()) return;

    var $current = $(this);

    var $items =
      $('.row-links .nav-dd .navdd');

    var currentIndex =
      $items.index($current);


    /* RIGHT */

    if (e.key === 'ArrowRight') {

      e.preventDefault();
      e.stopPropagation();

      var nextIndex =
        currentIndex + 1;

      if (nextIndex >= $items.length) {
        nextIndex = 0;
      }

      $items.eq(nextIndex).focus();

      return;
    }


    /* LEFT */

    if (e.key === 'ArrowLeft') {

      e.preventDefault();
      e.stopPropagation();

      var previousIndex =
        currentIndex - 1;

      if (previousIndex < 0) {
        previousIndex = $items.length - 1;
      }

      $items.eq(previousIndex).focus();

      return;
    }


    /* DOWN */

    if (e.key === 'ArrowDown') {

      e.preventDefault();
      e.stopPropagation();

      var $navItem =
        $current.closest('.nav-dd');

      if ($navItem.hasClass('reglink')) {
        return;
      }

      openMegaMenu($navItem, true);

      return;
    }

  });


  /* =========================================================
     UP FROM MEGA MENU
     ========================================================= */

  $('.megamenu').on(
    'keydown',
    'a.menulink',
    function(e){

      if (!isDesktop()) return;

      if (e.key !== 'ArrowUp') return;

      e.preventDefault();
      e.stopPropagation();

      var $currentMenu =
        $(this).closest('.link-area');

      var menuId =
        $currentMenu.attr('id');

      if (!menuId) return;

      var navNumber =
        menuId.replace('nav-', '');

      var $trigger = $(
        '.row-links .nav-dd[data-num="' +
        navNumber +
        '"] .navdd'
      );

      if ($trigger.length) {

        $trigger.focus();
      }
    }
  );


  /* =========================================================
     INITIAL ARIA STATE
     ========================================================= */

  $('.row-links .navdd')
    .attr('aria-expanded', 'false');

});


/* =========================================================
   PAGE SCROLL
   ========================================================= */

$(document).scroll(function(){

  if ($(document).scrollTop() >= 400){

    $('.topbar').slideUp();
  }

  if ($(document).scrollTop() < 100){

    $('.topbar').slideDown();
  }

});